var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPosDevice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 541.405,
    height: 537.5,
    viewBox: "0 0 541.405 537.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_647",
    "data-name": "Ellipse 647",
    cx: 244,
    cy: 244,
    r: 244,
    transform: "translate(807.612 162)",
    fill: "rgba(0,0,0,0.12)"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2035"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.161,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2036",
    x: 183.846,
    y: 437.831,
    width: 52.732,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2036-2",
    x: 183.846,
    y: 437.831,
    width: 52.732,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2037",
    x: 249.379,
    y: 437.831,
    width: 52.731,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2037-2",
    x: 249.379,
    y: 437.831,
    width: 52.731,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2038",
    x: 314.912,
    y: 437.831,
    width: 52.73,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2038-2",
    x: 314.912,
    y: 437.831,
    width: 52.73,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-7"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2039",
    x: 183.846,
    y: 397.411,
    width: 52.732,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-8"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2039-2",
    x: 183.846,
    y: 397.411,
    width: 52.732,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-9"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2040",
    x: 249.379,
    y: 397.411,
    width: 52.731,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-10"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2040-2",
    x: 249.379,
    y: 397.411,
    width: 52.731,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-11"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2041",
    x: 314.912,
    y: 397.411,
    width: 52.73,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-12"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2041-2",
    x: 314.912,
    y: 397.411,
    width: 52.73,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-13"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-7"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2042",
    x: 183.846,
    y: 356.989,
    width: 52.732,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-14"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2042-2",
    x: 183.846,
    y: 356.989,
    width: 52.732,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-15"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-8"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2043",
    x: 249.379,
    y: 356.989,
    width: 52.731,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-16"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2043-2",
    x: 249.379,
    y: 356.989,
    width: 52.731,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-17"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-9"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2044",
    x: 314.912,
    y: 356.989,
    width: 52.73,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-18"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2044-2",
    x: 314.912,
    y: 356.989,
    width: 52.73,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-19"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-10"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2045",
    x: 183.846,
    y: 316.568,
    width: 52.732,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-20"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-20"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2045-2",
    x: 183.846,
    y: 316.568,
    width: 52.732,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-21"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.239,
    result: "color-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-21"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-11"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2046",
    x: 249.379,
    y: 316.568,
    width: 52.731,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-22"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-22"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2046-2",
    x: 249.379,
    y: 316.568,
    width: 52.731,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-23"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-23"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-12"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2047",
    x: 314.912,
    y: 316.568,
    width: 52.73,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-24"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.122
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-24"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2047-2",
    x: 314.912,
    y: 316.568,
    width: 52.73,
    height: 30.614,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-25"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-25"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-13"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2048",
    x: 176.693,
    y: 86.268,
    width: 197.498,
    height: 208.761,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-26"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-26"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-14"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2049"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-27"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.239,
    result: "color-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-27"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-15"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2050"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-28"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-28"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-16"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2051"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-29"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-29"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-17"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_2052"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-30"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    floodOpacity: 0.322,
    result: "color-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-30"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-18"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2127",
    "data-name": "Rectangle 2127",
    width: 145,
    height: 93,
    transform: "translate(50.224 4.059)",
    fill: "#f8b7b7"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Union_26"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-31"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161,
    result: "color-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-31"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color-19"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_646",
    x: 230.074,
    y: 139.183,
    width: 92.702,
    height: 94.702,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-32"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-32"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5910",
    "data-name": "Group 5910",
    transform: "translate(-776 -161.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(796 174.648)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Dot_Pattern-Small",
    "data-name": "Dot Pattern-Small",
    d: "M103.237,270.953a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,270.953Zm-13.439,0a1.92,1.92,0,0,1,1.92,1.92c0,1.06-3.84,1.06-3.84,0A1.92,1.92,0,0,1,89.8,270.953Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,270.953Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,270.953Zm69.116-11.519a1.92,1.92,0,1,1-3.84,0C128.2,258.373,132.036,258.373,132.036,259.433Zm-15.359-1.92a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,257.513Zm67.2-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,244.074Zm80.635-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,230.635ZM156.994,217.2a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,217.2Zm107.513-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,203.757Zm120.953-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,190.318Zm120.953-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,176.878Zm-13.439,0A1.92,1.92,0,1,1,61,178.8,1.92,1.92,0,0,1,62.92,176.878Zm120.953-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,163.439ZM183.873,150a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,150ZM89.8,150a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,150ZM62.92,150A1.92,1.92,0,1,1,61,151.92,1.92,1.92,0,0,1,62.92,150Z",
    transform: "translate(-81 -160)",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5303",
    "data-name": "Group 5303",
    transform: "translate(807.612 162)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_316",
    "data-name": "Ellipse 316",
    cx: 244,
    cy: 244,
    r: 244,
    transform: "translate(0.388)",
    fill: "rgba(0,0,0,0.16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M183.873,274.792a1.92,1.92,0,0,1-1.92-1.92C181.953,271.812,184.933,274.792,183.873,274.792Zm-13.439-3.84a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,270.953Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,270.953Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,270.953Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,270.953Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,270.953Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,270.953Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,270.953Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,270.953Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,270.953Zm120.953-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,257.513Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,257.513Zm120.953-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,244.074Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,244.074Zm120.953-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,230.635Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,230.635ZM183.873,217.2a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,217.2Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,217.2Zm120.953-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,203.757Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,203.757Zm120.953-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,190.318Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,62.92,190.318Zm120.953-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,176.878Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,76.359,176.878Zm107.514-13.439a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,163.439Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,89.8,163.439ZM183.873,150a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,183.873,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,170.433,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,156.994,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,143.555,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,130.116,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,116.677,150Zm-13.439,0a1.92,1.92,0,1,1-1.92,1.92A1.92,1.92,0,0,1,103.237,150Z",
    transform: "translate(324 262.648)",
    fill: "#fff",
    fillRule: "evenodd",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5889",
    "data-name": "Group 5889"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_43",
    "data-name": "Mask Group 43",
    transform: "translate(-0.224 -0.059)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    transform: "translate(1023.707 226.203)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2129",
    "data-name": "Rectangle 2129",
    width: 269.854,
    height: 428.54,
    transform: "translate(8.581 4.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2130",
    "data-name": "Rectangle 2130",
    width: 252.987,
    height: 132.42,
    transform: "translate(17.016 211.954)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2131",
    "data-name": "Rectangle 2131",
    width: 252.987,
    height: 90.203,
    transform: "translate(17.016 12.934)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5936",
    "data-name": "Group 5936",
    transform: "translate(189.391 263.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2132",
    "data-name": "Rectangle 2132",
    width: 48.397,
    height: 60.131,
    transform: "translate(0 7.992)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2133",
    "data-name": "Rectangle 2133",
    width: 32.895,
    height: 28.634,
    transform: "translate(7.753 29.259)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2134",
    "data-name": "Rectangle 2134",
    width: 48.397,
    height: 7.992,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5934",
    "data-name": "Group 5934",
    transform: "translate(12.116 43.312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_676",
    "data-name": "Ellipse 676",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2135",
    "data-name": "Rectangle 2135",
    width: 1.873,
    height: 0.905,
    transform: "translate(14.173 4.994) rotate(-19.47)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2136",
    "data-name": "Rectangle 2136",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.507 3.027) rotate(11.33)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2137",
    "data-name": "Rectangle 2137",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.993, 0.115, -0.115, 0.993, 8.525, 6.297)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5935",
    "data-name": "Group 5935",
    transform: "translate(16.542 33.278)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_677",
    "data-name": "Ellipse 677",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    transform: "translate(0 3.587) rotate(-10.34)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2138",
    "data-name": "Rectangle 2138",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.868, -0.497, 0.497, 0.868, 14.842, 5.958)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2139",
    "data-name": "Rectangle 2139",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.98 5.754) rotate(0.99)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2140",
    "data-name": "Rectangle 2140",
    width: 1.873,
    height: 0.905,
    transform: "translate(9.523 8.252) rotate(-3.74)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2141",
    "data-name": "Rectangle 2141",
    width: 1.873,
    height: 0.905,
    transform: "translate(10.734 4.05) rotate(18.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5939",
    "data-name": "Group 5939",
    transform: "translate(115.964 263.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2142",
    "data-name": "Rectangle 2142",
    width: 48.397,
    height: 60.131,
    transform: "translate(0 7.992)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2143",
    "data-name": "Rectangle 2143",
    width: 32.895,
    height: 28.634,
    transform: "translate(7.751 29.259)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2144",
    "data-name": "Rectangle 2144",
    width: 48.397,
    height: 7.992,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5937",
    "data-name": "Group 5937",
    transform: "translate(12.115 43.312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_678",
    "data-name": "Ellipse 678",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2145",
    "data-name": "Rectangle 2145",
    width: 1.873,
    height: 0.905,
    transform: "translate(14.172 4.996) rotate(-19.47)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2146",
    "data-name": "Rectangle 2146",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.509 3.027) rotate(11.33)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2147",
    "data-name": "Rectangle 2147",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.993, 0.115, -0.115, 0.993, 8.527, 6.292)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5938",
    "data-name": "Group 5938",
    transform: "translate(16.543 33.278)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_679",
    "data-name": "Ellipse 679",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    transform: "translate(0 3.587) rotate(-10.34)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2148",
    "data-name": "Rectangle 2148",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.868, -0.497, 0.497, 0.868, 14.84, 5.957)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149",
    "data-name": "Rectangle 2149",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.978 5.755) rotate(0.99)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150",
    "data-name": "Rectangle 2150",
    width: 1.873,
    height: 0.905,
    transform: "translate(9.52 8.247) rotate(-3.74)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151",
    "data-name": "Rectangle 2151",
    width: 1.873,
    height: 0.905,
    transform: "translate(10.73 4.053) rotate(18.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5942",
    "data-name": "Group 5942",
    transform: "translate(42.499 263.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2152",
    "data-name": "Rectangle 2152",
    width: 48.397,
    height: 60.131,
    transform: "translate(0 7.992)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2153",
    "data-name": "Rectangle 2153",
    width: 32.895,
    height: 28.634,
    transform: "translate(7.753 29.259)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2154",
    "data-name": "Rectangle 2154",
    width: 48.397,
    height: 7.992,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5940",
    "data-name": "Group 5940",
    transform: "translate(12.116 43.312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_680",
    "data-name": "Ellipse 680",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2155",
    "data-name": "Rectangle 2155",
    width: 1.873,
    height: 0.905,
    transform: "translate(14.172 4.995) rotate(-19.47)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2156",
    "data-name": "Rectangle 2156",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.508 3.029) rotate(11.33)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2157",
    "data-name": "Rectangle 2157",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.993, 0.115, -0.115, 0.993, 8.526, 6.288)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5941",
    "data-name": "Group 5941",
    transform: "translate(16.543 33.277)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_681",
    "data-name": "Ellipse 681",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    transform: "translate(0 3.587) rotate(-10.34)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2158",
    "data-name": "Rectangle 2158",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.868, -0.497, 0.497, 0.868, 14.84, 5.958)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2159",
    "data-name": "Rectangle 2159",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.978 5.758) rotate(0.99)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2160",
    "data-name": "Rectangle 2160",
    width: 1.873,
    height: 0.905,
    transform: "translate(9.52 8.243) rotate(-3.74)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2161",
    "data-name": "Rectangle 2161",
    width: 1.873,
    height: 0.905,
    transform: "translate(10.73 4.057) rotate(18.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2162",
    "data-name": "Rectangle 2162",
    width: 278.017,
    height: 13.031,
    transform: "translate(4.5 90.105)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2163",
    "data-name": "Rectangle 2163",
    width: 252.987,
    height: 90.203,
    transform: "translate(17.016 112.078)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2164",
    "data-name": "Rectangle 2164",
    width: 278.017,
    height: 13.031,
    transform: "translate(4.5 189.721)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2165",
    "data-name": "Rectangle 2165",
    width: 278.017,
    height: 13.031,
    transform: "translate(4.5 331.487)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5943",
    "data-name": "Group 5943",
    transform: "translate(53.2 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M288.465,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H278.82V229.735A9.65,9.65,0,0,1,288.465,220.09Z",
    transform: "translate(-278.82 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2166",
    "data-name": "Rectangle 2166",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2167",
    "data-name": "Rectangle 2167",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5944",
    "data-name": "Group 5944",
    transform: "translate(84.515 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M464.855,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H455.21V229.735A9.65,9.65,0,0,1,464.855,220.09Z",
    transform: "translate(-455.21 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2168",
    "data-name": "Rectangle 2168",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2169",
    "data-name": "Rectangle 2169",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5945",
    "data-name": "Group 5945",
    transform: "translate(115.513 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M639.465,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H629.82V229.735A9.65,9.65,0,0,1,639.465,220.09Z",
    transform: "translate(-629.82 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2170",
    "data-name": "Rectangle 2170",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2171",
    "data-name": "Rectangle 2171",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5946",
    "data-name": "Group 5946",
    transform: "translate(146.872 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M816.115,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H806.47V229.735A9.65,9.65,0,0,1,816.115,220.09Z",
    transform: "translate(-806.468 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2172",
    "data-name": "Rectangle 2172",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2173",
    "data-name": "Rectangle 2173",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5947",
    "data-name": "Group 5947",
    transform: "translate(178.187 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M992.5,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H982.85V229.735a9.65,9.65,0,0,1,9.645-9.645Z",
    transform: "translate(-982.85 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2174",
    "data-name": "Rectangle 2174",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2175",
    "data-name": "Rectangle 2175",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5948",
    "data-name": "Group 5948",
    transform: "translate(209.186 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M1167.105,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H1157.46V229.735a9.65,9.65,0,0,1,9.645-9.645Z",
    transform: "translate(-1157.46 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2176",
    "data-name": "Rectangle 2176",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2177",
    "data-name": "Rectangle 2177",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M263.666,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H259.02V719.506A4.649,4.649,0,0,1,263.666,714.86Z",
    transform: "translate(-209.335 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2178",
    "data-name": "Rectangle 2178",
    width: 10.812,
    height: 47.438,
    transform: "translate(53.435 136.448)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2179",
    "data-name": "Rectangle 2179",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(53.435 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M400.416,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H395.77V719.506A4.649,4.649,0,0,1,400.416,714.86Z",
    transform: "translate(-321.808 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2180",
    "data-name": "Rectangle 2180",
    width: 10.812,
    height: 47.438,
    transform: "translate(77.71 136.448)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2181",
    "data-name": "Rectangle 2181",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(77.71 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M536.3,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H531.65V719.506A4.649,4.649,0,0,1,536.3,714.86Z",
    transform: "translate(-433.565 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2182",
    "data-name": "Rectangle 2182",
    width: 10.812,
    height: 47.438,
    transform: "translate(101.835 136.448)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2183",
    "data-name": "Rectangle 2183",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(101.835 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M674.1,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H669.45V719.506A4.649,4.649,0,0,1,674.1,714.86Z",
    transform: "translate(-546.901 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2184",
    "data-name": "Rectangle 2184",
    width: 10.812,
    height: 47.438,
    transform: "translate(126.297 136.448)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2185",
    "data-name": "Rectangle 2185",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(126.297 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M810.836,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H806.19V719.506A4.649,4.649,0,0,1,810.836,714.86Z",
    transform: "translate(-659.365 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2187",
    "data-name": "Rectangle 2187",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(150.574 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M946.726,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H942.08V719.506a4.649,4.649,0,0,1,4.646-4.646Z",
    transform: "translate(-771.131 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2189",
    "data-name": "Rectangle 2189",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(174.697 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M1081.626,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H1076.98V719.506A4.649,4.649,0,0,1,1081.626,714.86Z",
    transform: "translate(-882.082 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2191",
    "data-name": "Rectangle 2191",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(198.648 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M1217.516,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H1212.87V719.506A4.649,4.649,0,0,1,1217.516,714.86Z",
    transform: "translate(-993.847 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2193",
    "data-name": "Rectangle 2193",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(222.772 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "_1-2",
    "data-name": "_1",
    transform: "translate(748.707 226.203)",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2129-2",
    "data-name": "Rectangle 2129",
    width: 269.854,
    height: 428.54,
    transform: "translate(8.581 4.5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2130-2",
    "data-name": "Rectangle 2130",
    width: 252.987,
    height: 132.42,
    transform: "translate(17.016 211.954)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2131-2",
    "data-name": "Rectangle 2131",
    width: 252.987,
    height: 90.203,
    transform: "translate(17.016 12.934)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5936-2",
    "data-name": "Group 5936",
    transform: "translate(189.391 263.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2132-2",
    "data-name": "Rectangle 2132",
    width: 48.397,
    height: 60.131,
    transform: "translate(0 7.992)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2133-2",
    "data-name": "Rectangle 2133",
    width: 32.895,
    height: 28.634,
    transform: "translate(7.753 29.259)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2134-2",
    "data-name": "Rectangle 2134",
    width: 48.397,
    height: 7.992,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5934-2",
    "data-name": "Group 5934",
    transform: "translate(12.116 43.312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_676-2",
    "data-name": "Ellipse 676",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2135-2",
    "data-name": "Rectangle 2135",
    width: 1.873,
    height: 0.905,
    transform: "translate(14.173 4.994) rotate(-19.47)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2136-2",
    "data-name": "Rectangle 2136",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.507 3.027) rotate(11.33)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2137-2",
    "data-name": "Rectangle 2137",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.993, 0.115, -0.115, 0.993, 8.525, 6.297)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5935-2",
    "data-name": "Group 5935",
    transform: "translate(16.542 33.278)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_677-2",
    "data-name": "Ellipse 677",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    transform: "translate(0 3.587) rotate(-10.34)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2138-2",
    "data-name": "Rectangle 2138",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.868, -0.497, 0.497, 0.868, 14.842, 5.958)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2139-2",
    "data-name": "Rectangle 2139",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.98 5.754) rotate(0.99)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2140-2",
    "data-name": "Rectangle 2140",
    width: 1.873,
    height: 0.905,
    transform: "translate(9.523 8.252) rotate(-3.74)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2141-2",
    "data-name": "Rectangle 2141",
    width: 1.873,
    height: 0.905,
    transform: "translate(10.734 4.05) rotate(18.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5939-2",
    "data-name": "Group 5939",
    transform: "translate(115.964 263.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2142-2",
    "data-name": "Rectangle 2142",
    width: 48.397,
    height: 60.131,
    transform: "translate(0 7.992)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2143-2",
    "data-name": "Rectangle 2143",
    width: 32.895,
    height: 28.634,
    transform: "translate(7.751 29.259)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2144-2",
    "data-name": "Rectangle 2144",
    width: 48.397,
    height: 7.992,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5937-2",
    "data-name": "Group 5937",
    transform: "translate(12.115 43.312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_678-2",
    "data-name": "Ellipse 678",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2145-2",
    "data-name": "Rectangle 2145",
    width: 1.873,
    height: 0.905,
    transform: "translate(14.172 4.996) rotate(-19.47)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2146-2",
    "data-name": "Rectangle 2146",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.509 3.027) rotate(11.33)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2147-2",
    "data-name": "Rectangle 2147",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.993, 0.115, -0.115, 0.993, 8.527, 6.292)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5938-2",
    "data-name": "Group 5938",
    transform: "translate(16.543 33.278)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_679-2",
    "data-name": "Ellipse 679",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    transform: "translate(0 3.587) rotate(-10.34)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2148-2",
    "data-name": "Rectangle 2148",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.868, -0.497, 0.497, 0.868, 14.84, 5.957)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2149-2",
    "data-name": "Rectangle 2149",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.978 5.755) rotate(0.99)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2150-2",
    "data-name": "Rectangle 2150",
    width: 1.873,
    height: 0.905,
    transform: "translate(9.52 8.247) rotate(-3.74)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2151-2",
    "data-name": "Rectangle 2151",
    width: 1.873,
    height: 0.905,
    transform: "translate(10.73 4.053) rotate(18.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5942-2",
    "data-name": "Group 5942",
    transform: "translate(42.499 263.363)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2152-2",
    "data-name": "Rectangle 2152",
    width: 48.397,
    height: 60.131,
    transform: "translate(0 7.992)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2153-2",
    "data-name": "Rectangle 2153",
    width: 32.895,
    height: 28.634,
    transform: "translate(7.753 29.259)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2154-2",
    "data-name": "Rectangle 2154",
    width: 48.397,
    height: 7.992,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5940-2",
    "data-name": "Group 5940",
    transform: "translate(12.116 43.312)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_680-2",
    "data-name": "Ellipse 680",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2155-2",
    "data-name": "Rectangle 2155",
    width: 1.873,
    height: 0.905,
    transform: "translate(14.172 4.995) rotate(-19.47)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2156-2",
    "data-name": "Rectangle 2156",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.508 3.029) rotate(11.33)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2157-2",
    "data-name": "Rectangle 2157",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.993, 0.115, -0.115, 0.993, 8.526, 6.288)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5941-2",
    "data-name": "Group 5941",
    transform: "translate(16.543 33.277)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_681-2",
    "data-name": "Ellipse 681",
    cx: 9.993,
    cy: 5.26,
    rx: 9.993,
    ry: 5.26,
    transform: "translate(0 3.587) rotate(-10.34)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2158-2",
    "data-name": "Rectangle 2158",
    width: 1.873,
    height: 0.905,
    transform: "matrix(0.868, -0.497, 0.497, 0.868, 14.84, 5.958)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2159-2",
    "data-name": "Rectangle 2159",
    width: 1.873,
    height: 0.905,
    transform: "translate(4.978 5.758) rotate(0.99)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2160-2",
    "data-name": "Rectangle 2160",
    width: 1.873,
    height: 0.905,
    transform: "translate(9.52 8.243) rotate(-3.74)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2161-2",
    "data-name": "Rectangle 2161",
    width: 1.873,
    height: 0.905,
    transform: "translate(10.73 4.057) rotate(18.39)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2162-2",
    "data-name": "Rectangle 2162",
    width: 278.017,
    height: 13.031,
    transform: "translate(4.5 90.105)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2163-2",
    "data-name": "Rectangle 2163",
    width: 252.987,
    height: 90.203,
    transform: "translate(17.016 112.078)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2164-2",
    "data-name": "Rectangle 2164",
    width: 278.017,
    height: 13.031,
    transform: "translate(4.5 189.721)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2165-2",
    "data-name": "Rectangle 2165",
    width: 278.017,
    height: 13.031,
    transform: "translate(4.5 331.487)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5943-2",
    "data-name": "Group 5943",
    transform: "translate(53.2 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2218-2",
    "data-name": "Path 2218",
    d: "M288.465,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H278.82V229.735A9.65,9.65,0,0,1,288.465,220.09Z",
    transform: "translate(-278.82 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2166-2",
    "data-name": "Rectangle 2166",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2167-2",
    "data-name": "Rectangle 2167",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5944-2",
    "data-name": "Group 5944",
    transform: "translate(84.515 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2219-2",
    "data-name": "Path 2219",
    d: "M464.855,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H455.21V229.735A9.65,9.65,0,0,1,464.855,220.09Z",
    transform: "translate(-455.21 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2168-2",
    "data-name": "Rectangle 2168",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2169-2",
    "data-name": "Rectangle 2169",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5945-2",
    "data-name": "Group 5945",
    transform: "translate(115.513 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2220-2",
    "data-name": "Path 2220",
    d: "M639.465,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H629.82V229.735A9.65,9.65,0,0,1,639.465,220.09Z",
    transform: "translate(-629.82 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2170-2",
    "data-name": "Rectangle 2170",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2171-2",
    "data-name": "Rectangle 2171",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5946-2",
    "data-name": "Group 5946",
    transform: "translate(146.872 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2221-2",
    "data-name": "Path 2221",
    d: "M816.115,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H806.47V229.735A9.65,9.65,0,0,1,816.115,220.09Z",
    transform: "translate(-806.468 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2172-2",
    "data-name": "Rectangle 2172",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2173-2",
    "data-name": "Rectangle 2173",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5947-2",
    "data-name": "Group 5947",
    transform: "translate(178.187 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2222-2",
    "data-name": "Path 2222",
    d: "M992.5,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H982.85V229.735a9.65,9.65,0,0,1,9.645-9.645Z",
    transform: "translate(-982.85 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2174-2",
    "data-name": "Rectangle 2174",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2175-2",
    "data-name": "Rectangle 2175",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5948-2",
    "data-name": "Group 5948",
    transform: "translate(209.186 35.263)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2223-2",
    "data-name": "Path 2223",
    d: "M1167.105,220.09h5.34a9.65,9.65,0,0,1,9.645,9.645v37.688H1157.46V229.735a9.65,9.65,0,0,1,9.645-9.645Z",
    transform: "translate(-1157.46 -212.579)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2176-2",
    "data-name": "Rectangle 2176",
    width: 9.796,
    height: 7.511,
    rx: 3.756,
    transform: "translate(7.417)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2177-2",
    "data-name": "Rectangle 2177",
    width: 24.631,
    height: 14.605,
    transform: "translate(0 25.082)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224-2",
    "data-name": "Path 2224",
    d: "M263.666,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H259.02V719.506A4.649,4.649,0,0,1,263.666,714.86Z",
    transform: "translate(-209.335 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2179-2",
    "data-name": "Rectangle 2179",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(53.435 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225-2",
    "data-name": "Path 2225",
    d: "M400.416,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H395.77V719.506A4.649,4.649,0,0,1,400.416,714.86Z",
    transform: "translate(-321.808 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2181-2",
    "data-name": "Rectangle 2181",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(77.71 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226-2",
    "data-name": "Path 2226",
    d: "M536.3,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H531.65V719.506A4.649,4.649,0,0,1,536.3,714.86Z",
    transform: "translate(-433.565 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2183-2",
    "data-name": "Rectangle 2183",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(101.835 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227-2",
    "data-name": "Path 2227",
    d: "M674.1,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H669.45V719.506A4.649,4.649,0,0,1,674.1,714.86Z",
    transform: "translate(-546.901 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2185-2",
    "data-name": "Rectangle 2185",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(126.297 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228-2",
    "data-name": "Path 2228",
    d: "M810.836,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H806.19V719.506A4.649,4.649,0,0,1,810.836,714.86Z",
    transform: "translate(-659.365 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2187-2",
    "data-name": "Rectangle 2187",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(150.574 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229-2",
    "data-name": "Path 2229",
    d: "M946.726,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H942.08V719.506a4.649,4.649,0,0,1,4.646-4.646Z",
    transform: "translate(-771.131 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2189-2",
    "data-name": "Rectangle 2189",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(174.697 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230-2",
    "data-name": "Path 2230",
    d: "M1081.626,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H1076.98V719.506A4.649,4.649,0,0,1,1081.626,714.86Z",
    transform: "translate(-882.082 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2191-2",
    "data-name": "Rectangle 2191",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(198.648 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231-2",
    "data-name": "Path 2231",
    d: "M1217.516,714.86h9.017a4.649,4.649,0,0,1,4.646,4.646V773.97H1212.87V719.506A4.649,4.649,0,0,1,1217.516,714.86Z",
    transform: "translate(-993.847 -584.249)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2193-2",
    "data-name": "Rectangle 2193",
    width: 10.812,
    height: 6.691,
    rx: 3.346,
    transform: "translate(222.772 123.92)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    transform: "translate(929 173)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "POS_Terminal"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5834",
    "data-name": "Group 5834"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5830",
    "data-name": "Group 5830",
    transform: "translate(0 75.268)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2035-2",
    "data-name": "Path 2035",
    d: "M243.936,660.87V989.239a23.5,23.5,0,0,1-23.55,23.55H23.643A23.586,23.586,0,0,1,0,989.239V660.87a23.585,23.585,0,0,1,23.643-23.55H220.388a23.5,23.5,0,0,1,23.55,23.55Z",
    transform: "translate(0 -606.057)",
    fill: "#4e65ac"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -152.78, -86.27)",
    filter: "url(#Path_2035)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2035-3",
    "data-name": "Path 2035",
    d: "M243.936,660.87V989.239a23.5,23.5,0,0,1-23.55,23.55H23.643A23.586,23.586,0,0,1,0,989.239V660.87a23.585,23.585,0,0,1,23.643-23.55H220.388a23.5,23.5,0,0,1,23.55,23.55Z",
    transform: "translate(152.78 -519.79)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5826",
    "data-name": "Group 5826",
    transform: "translate(31.07 351.563)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -437.83)",
    filter: "url(#Path_2036)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2036-3",
    "data-name": "Path 2036",
    d: "M240.162,2594.813v18.308a4.67,4.67,0,0,1-4.653,4.653H194.045a4.637,4.637,0,0,1-4.615-4.653v-18.308a4.637,4.637,0,0,1,4.615-4.653h41.462a4.669,4.669,0,0,1,4.653,4.653Z",
    transform: "translate(-5.58 -2152.33)",
    fill: "#c38c84"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -437.83)",
    filter: "url(#Path_2036-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2036-4",
    "data-name": "Path 2036",
    d: "M240.162,2594.813v18.308a4.67,4.67,0,0,1-4.653,4.653H194.045a4.637,4.637,0,0,1-4.615-4.653v-18.308a4.637,4.637,0,0,1,4.615-4.653h41.462a4.669,4.669,0,0,1,4.653,4.653Z",
    transform: "translate(-5.58 -2152.33)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -437.83)",
    filter: "url(#Path_2037)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2037-3",
    "data-name": "Path 2037",
    d: "M639.711,2594.813v18.308a4.67,4.67,0,0,1-4.653,4.653H593.6a4.638,4.638,0,0,1-4.615-4.653v-18.308a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,639.711,2594.813Z",
    transform: "translate(-339.6 -2152.33)",
    fill: "#95a4d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -437.83)",
    filter: "url(#Path_2037-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2037-4",
    "data-name": "Path 2037",
    d: "M639.711,2594.813v18.308a4.67,4.67,0,0,1-4.653,4.653H593.6a4.638,4.638,0,0,1-4.615-4.653v-18.308a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,639.711,2594.813Z",
    transform: "translate(-339.6 -2152.33)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -437.83)",
    filter: "url(#Path_2038)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2038-3",
    "data-name": "Path 2038",
    d: "M1039.26,2594.813v18.308a4.67,4.67,0,0,1-4.653,4.653H993.145a4.637,4.637,0,0,1-4.615-4.653v-18.308a4.636,4.636,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,1039.26,2594.813Z",
    transform: "translate(-673.62 -2152.33)",
    fill: "#6fb4a1"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -437.83)",
    filter: "url(#Path_2038-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2038-4",
    "data-name": "Path 2038",
    d: "M1039.26,2594.813v18.308a4.67,4.67,0,0,1-4.653,4.653H993.145a4.637,4.637,0,0,1-4.615-4.653v-18.308a4.636,4.636,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,1039.26,2594.813Z",
    transform: "translate(-673.62 -2152.33)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5827",
    "data-name": "Group 5827",
    transform: "translate(31.07 311.142)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -397.41)",
    filter: "url(#Path_2039)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2039-3",
    "data-name": "Path 2039",
    d: "M240.162,2348.373v18.308a4.67,4.67,0,0,1-4.653,4.653H194.045a4.637,4.637,0,0,1-4.615-4.653v-18.308a4.637,4.637,0,0,1,4.615-4.653h41.462a4.669,4.669,0,0,1,4.653,4.653Z",
    transform: "translate(-5.58 -1946.31)",
    fill: "#95a4d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -397.41)",
    filter: "url(#Path_2039-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2039-4",
    "data-name": "Path 2039",
    d: "M240.162,2348.373v18.308a4.67,4.67,0,0,1-4.653,4.653H194.045a4.637,4.637,0,0,1-4.615-4.653v-18.308a4.637,4.637,0,0,1,4.615-4.653h41.462a4.669,4.669,0,0,1,4.653,4.653Z",
    transform: "translate(-5.58 -1946.31)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -397.41)",
    filter: "url(#Path_2040)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040-3",
    "data-name": "Path 2040",
    d: "M639.711,2348.373v18.308a4.67,4.67,0,0,1-4.653,4.653H593.6a4.638,4.638,0,0,1-4.615-4.653v-18.308a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,639.711,2348.373Z",
    transform: "translate(-339.6 -1946.31)",
    fill: "#95a4d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -397.41)",
    filter: "url(#Path_2040-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2040-4",
    "data-name": "Path 2040",
    d: "M639.711,2348.373v18.308a4.67,4.67,0,0,1-4.653,4.653H593.6a4.638,4.638,0,0,1-4.615-4.653v-18.308a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,639.711,2348.373Z",
    transform: "translate(-339.6 -1946.31)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -397.41)",
    filter: "url(#Path_2041)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2041-3",
    "data-name": "Path 2041",
    d: "M1039.26,2348.373v18.308a4.67,4.67,0,0,1-4.653,4.653H993.145a4.637,4.637,0,0,1-4.615-4.653v-18.308a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,1039.26,2348.373Z",
    transform: "translate(-673.62 -1946.31)",
    fill: "#95a4d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -397.41)",
    filter: "url(#Path_2041-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2041-4",
    "data-name": "Path 2041",
    d: "M1039.26,2348.373v18.308a4.67,4.67,0,0,1-4.653,4.653H993.145a4.637,4.637,0,0,1-4.615-4.653v-18.308a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,1039.26,2348.373Z",
    transform: "translate(-673.62 -1946.31)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5828",
    "data-name": "Group 5828",
    transform: "translate(31.07 270.72)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -356.99)",
    filter: "url(#Path_2042)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042-3",
    "data-name": "Path 2042",
    d: "M240.162,2101.923v18.307a4.67,4.67,0,0,1-4.653,4.653H194.045a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462a4.669,4.669,0,0,1,4.653,4.653Z",
    transform: "translate(-5.58 -1740.28)",
    fill: "#95a4d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -356.99)",
    filter: "url(#Path_2042-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2042-4",
    "data-name": "Path 2042",
    d: "M240.162,2101.923v18.307a4.67,4.67,0,0,1-4.653,4.653H194.045a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462a4.669,4.669,0,0,1,4.653,4.653Z",
    transform: "translate(-5.58 -1740.28)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -356.99)",
    filter: "url(#Path_2043)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2043-3",
    "data-name": "Path 2043",
    d: "M639.711,2101.923v18.307a4.67,4.67,0,0,1-4.653,4.653H593.6a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,639.711,2101.923Z",
    transform: "translate(-339.6 -1740.28)",
    fill: "#95a4d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -356.99)",
    filter: "url(#Path_2043-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2043-4",
    "data-name": "Path 2043",
    d: "M639.711,2101.923v18.307a4.67,4.67,0,0,1-4.653,4.653H593.6a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,639.711,2101.923Z",
    transform: "translate(-339.6 -1740.28)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -356.99)",
    filter: "url(#Path_2044)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2044-3",
    "data-name": "Path 2044",
    d: "M1039.26,2101.923v18.307a4.67,4.67,0,0,1-4.653,4.653H993.145a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,1039.26,2101.923Z",
    transform: "translate(-673.62 -1740.28)",
    fill: "#95a4d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -356.99)",
    filter: "url(#Path_2044-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2044-4",
    "data-name": "Path 2044",
    d: "M1039.26,2101.923v18.307a4.67,4.67,0,0,1-4.653,4.653H993.145a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,1039.26,2101.923Z",
    transform: "translate(-673.62 -1740.28)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5829",
    "data-name": "Group 5829",
    transform: "translate(31.07 230.3)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -316.57)",
    filter: "url(#Path_2045)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2045-3",
    "data-name": "Path 2045",
    d: "M240.162,1855.483v18.307a4.67,4.67,0,0,1-4.653,4.653H194.045a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462a4.669,4.669,0,0,1,4.653,4.653Z",
    transform: "translate(-5.58 -1534.26)",
    fill: "#95a4d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -316.57)",
    filter: "url(#Path_2045-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2045-4",
    "data-name": "Path 2045",
    d: "M240.162,1855.483v18.307a4.67,4.67,0,0,1-4.653,4.653H194.045a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462a4.669,4.669,0,0,1,4.653,4.653Z",
    transform: "translate(-5.58 -1534.26)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -316.57)",
    filter: "url(#Path_2046)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046-3",
    "data-name": "Path 2046",
    d: "M639.711,1855.483v18.307a4.67,4.67,0,0,1-4.653,4.653H593.6a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,639.711,1855.483Z",
    transform: "translate(-339.6 -1534.26)",
    fill: "#95a4d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -316.57)",
    filter: "url(#Path_2046-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046-4",
    "data-name": "Path 2046",
    d: "M639.711,1855.483v18.307a4.67,4.67,0,0,1-4.653,4.653H593.6a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,639.711,1855.483Z",
    transform: "translate(-339.6 -1534.26)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -316.57)",
    filter: "url(#Path_2047)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2047-3",
    "data-name": "Path 2047",
    d: "M1039.26,1855.483v18.307a4.67,4.67,0,0,1-4.653,4.653H993.145a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,1039.26,1855.483Z",
    transform: "translate(-673.62 -1534.26)",
    fill: "#95a4d2"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -183.85, -316.57)",
    filter: "url(#Path_2047-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2047-4",
    "data-name": "Path 2047",
    d: "M1039.26,1855.483v18.307a4.67,4.67,0,0,1-4.653,4.653H993.145a4.638,4.638,0,0,1-4.615-4.653v-18.307a4.637,4.637,0,0,1,4.615-4.653h41.462A4.669,4.669,0,0,1,1039.26,1855.483Z",
    transform: "translate(-673.62 -1534.26)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2048-2",
    "data-name": "Path 2048",
    d: "M343.318,461.132V641.01a14.47,14.47,0,0,1-14.461,14.461H160.281A14.445,14.445,0,0,1,145.82,641.01V461.132a14.436,14.436,0,0,1,14.461-14.422H328.857A14.46,14.46,0,0,1,343.318,461.132Z",
    transform: "translate(-121.903 -446.71)",
    fill: "#3b5195"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -152.78, -86.27)",
    filter: "url(#Path_2048)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2048-3",
    "data-name": "Path 2048",
    d: "M343.318,461.132V641.01a14.47,14.47,0,0,1-14.461,14.461H160.281A14.445,14.445,0,0,1,145.82,641.01V461.132a14.436,14.436,0,0,1,14.461-14.422H328.857A14.46,14.46,0,0,1,343.318,461.132Z",
    transform: "translate(30.87 -360.44)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2049-2",
    "data-name": "Path 2049",
    d: "M268.236,721.06H412.8a8.22,8.22,0,0,1,8.216,8.216v95.1a8.219,8.219,0,0,1-8.216,8.216H268.236a8.219,8.219,0,0,1-8.216-8.216v-95.1A8.219,8.219,0,0,1,268.236,721.06Z",
    transform: "translate(-217.372 -676.062)",
    fill: "#ccfeff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -152.78, -86.27)",
    filter: "url(#Path_2049)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2049-3",
    "data-name": "Path 2049",
    d: "M268.236,721.06H412.8a8.22,8.22,0,0,1,8.216,8.216v95.1a8.219,8.219,0,0,1-8.216,8.216H268.236a8.219,8.219,0,0,1-8.216-8.216v-95.1A8.219,8.219,0,0,1,268.236,721.06Z",
    transform: "translate(-64.6 -589.79)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2050-2",
    "data-name": "Path 2050",
    d: "M304.511,1525.138v8.153a3.523,3.523,0,0,1-3.539,3.5H263.548a3.52,3.52,0,0,1-3.538-3.5v-8.153a3.528,3.528,0,0,1,3.538-3.538h37.424A3.529,3.529,0,0,1,304.511,1525.138Z",
    transform: "translate(-217.364 -1345.299)",
    fill: "#283662"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -152.78, -86.27)",
    filter: "url(#Path_2050)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2050-3",
    "data-name": "Path 2050",
    d: "M304.511,1525.138v8.153a3.523,3.523,0,0,1-3.539,3.5H263.548a3.52,3.52,0,0,1-3.538-3.5v-8.153a3.528,3.528,0,0,1,3.538-3.538h37.424A3.529,3.529,0,0,1,304.511,1525.138Z",
    transform: "translate(-64.59 -1259.03)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2051-2",
    "data-name": "Path 2051",
    d: "M659.651,1525.138v8.153a3.523,3.523,0,0,1-3.54,3.5H618.688a3.52,3.52,0,0,1-3.538-3.5v-8.153a3.528,3.528,0,0,1,3.538-3.538h37.424A3.529,3.529,0,0,1,659.651,1525.138Z",
    transform: "translate(-514.255 -1345.299)",
    fill: "#283662"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -152.78, -86.27)",
    filter: "url(#Path_2051)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2051-3",
    "data-name": "Path 2051",
    d: "M659.651,1525.138v8.153a3.523,3.523,0,0,1-3.54,3.5H618.688a3.52,3.52,0,0,1-3.538-3.5v-8.153a3.528,3.528,0,0,1,3.538-3.538h37.424A3.529,3.529,0,0,1,659.651,1525.138Z",
    transform: "translate(-361.48 -1259.03)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2052-2",
    "data-name": "Path 2052",
    d: "M1014.8,1525.138v8.153a3.523,3.523,0,0,1-3.539,3.5H973.838a3.52,3.52,0,0,1-3.538-3.5v-8.153a3.528,3.528,0,0,1,3.538-3.538h37.424A3.529,3.529,0,0,1,1014.8,1525.138Z",
    transform: "translate(-811.154 -1345.299)",
    fill: "#283662"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -152.78, -86.27)",
    filter: "url(#Path_2052)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2052-3",
    "data-name": "Path 2052",
    d: "M1014.8,1525.138v8.153a3.523,3.523,0,0,1-3.539,3.5H973.838a3.52,3.52,0,0,1-3.538-3.5v-8.153a3.528,3.528,0,0,1,3.538-3.538h37.424A3.529,3.529,0,0,1,1014.8,1525.138Z",
    transform: "translate(-658.38 -1259.03)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_81",
    "data-name": "Line 81",
    x2: 1.704,
    y2: 18.5,
    transform: "translate(262.49 218.53)",
    fill: "#f95d5d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2191",
    "data-name": "Path 2191",
    d: "M412.06,550.267a3.674,3.674,0,0,1-3.666,3.679H251.786a3.673,3.673,0,0,1-2.59-6.27,3.6,3.6,0,0,1,2.59-1.076H408.394a3.666,3.666,0,0,1,3.666,3.666Z",
    transform: "translate(-207.424 -456.948)",
    fill: "#28396e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_55",
    "data-name": "Mask Group 55",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5832",
    "data-name": "Group 5832",
    transform: "translate(40.696)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_26-2",
    "data-name": "Union 26",
    d: "M1109.527,2741v-85.458l.088.019,5-4.5,5.035,4.532h.1l5.038-4.532,5.036,4.532h.1l5.039-4.532,5.039,4.532h.1l5.035-4.532,5.029,4.532h.1l5.038-4.532,5.036,4.532h.1l5.039-4.532,5.038,4.532h.1l5.036-4.532,5.037,4.532h.1l5.038-4.532,5.038,4.532h.1l5.036-4.532,5.037,4.532h.1l5.029-4.532,5.037,4.532h.1l5.037-4.532,5.039,4.532h.1l5.036-4.532,5.037,4.532h.1l5.04-4.532,5.036,4.532h.1l5.037-4.532,5,4.5.088-.019V2741Z",
    transform: "translate(-1098.77 -2644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -193.47, -11)",
    filter: "url(#Union_26)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union_26-3",
    "data-name": "Union 26",
    d: "M1109.527,2741v-85.458l.088.019,5-4.5,5.035,4.532h.1l5.038-4.532,5.036,4.532h.1l5.039-4.532,5.039,4.532h.1l5.035-4.532,5.029,4.532h.1l5.038-4.532,5.036,4.532h.1l5.039-4.532,5.038,4.532h.1l5.036-4.532,5.037,4.532h.1l5.038-4.532,5.038,4.532h.1l5.036-4.532,5.037,4.532h.1l5.029-4.532,5.037,4.532h.1l5.037-4.532,5.039,4.532h.1l5.036-4.532,5.037,4.532h.1l5.04-4.532,5.036,4.532h.1l5.037-4.532,5,4.5.088-.019V2741Z",
    transform: "translate(-905.3 -2633)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5831",
    "data-name": "Group 5831",
    transform: "translate(37.307 36.144)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2055",
    "data-name": "Path 2055",
    d: "M471.807,182.187H384.519a1.019,1.019,0,1,1,0-2.037h87.288a1.019,1.019,0,0,1,0,2.037Z",
    transform: "translate(-383.5 -180.15)",
    fill: "rgba(98,120,188,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2056",
    "data-name": "Path 2056",
    d: "M471.807,282.757H384.519a1.019,1.019,0,1,1,0-2.037h87.288a1.019,1.019,0,0,1,0,2.037Z",
    transform: "translate(-383.5 -268.393)",
    fill: "rgba(98,120,188,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2057",
    "data-name": "Path 2057",
    d: "M428.162,383.317H384.519a1.019,1.019,0,1,1,0-2.037h43.642a1.019,1.019,0,1,1,0,2.037Z",
    transform: "translate(-383.5 -356.627)",
    fill: "rgba(98,120,188,0.3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2058",
    "data-name": "Path 2058",
    d: "M428.162,483.887H384.519a1.019,1.019,0,1,1,0-2.037h43.642a1.019,1.019,0,1,1,0,2.037Z",
    transform: "translate(-383.5 -444.87)",
    fill: "rgba(98,120,188,0.3)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2190",
    "data-name": "Path 2190",
    d: "M861.881,397.269H826.3a1.093,1.093,0,0,1-1.093-1.093V382.383a1.093,1.093,0,0,1,1.093-1.093h35.578a1.093,1.093,0,0,1,1.093,1.093v13.792A1.093,1.093,0,0,1,861.881,397.269ZM827.4,395.082h33.392V383.475H827.4Z",
    transform: "translate(-734.898 -321.781)",
    fill: "rgba(98,120,188,0.3)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5833",
    "data-name": "Group 5833",
    transform: "translate(77.298 128.183)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -230.07, -139.18)",
    filter: "url(#Ellipse_646)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_646-2",
    "data-name": "Ellipse 646",
    cx: 32.421,
    cy: 32.421,
    r: 32.421,
    transform: "translate(230.07 185.03) rotate(-45)",
    fill: "#36a365"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2059",
    "data-name": "Path 2059",
    d: "M674.011,1022.466a3.986,3.986,0,0,1-2.808-1.534l-5.911-7.628a3.994,3.994,0,0,1,6.315-4.891l3.531,4.558,11.911-8.711a3.994,3.994,0,1,1,4.715,6.448l-15.045,11A3.985,3.985,0,0,1,674.011,1022.466Z",
    transform: "translate(-632.77 -967.083)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x1: 11.186,
    y1: 12.629,
    transform: "translate(0.138 190.69)",
    fill: "#fac896"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosDevice);
export default __webpack_public_path__ + "static/media/pos-device.7e6959ff037a62cb19eaa2934fce0466.svg";
export { ForwardRef as ReactComponent };